import Image from 'next/legacy/image';
import React from 'react';

import tickSvg from '@/hox-core/resources/controls/tick.svg';
import { Card } from '@/ui/layout/Card.component';
import { useTheme } from '@/ui/theme';

type AlertCardProps = {
  children: React.ReactNode;
  type: 'info' | 'success' | 'warning';
  className?: string;
};

const AlertIcon = (props: { type: AlertCardProps['type'] }) => {
  switch (props.type) {
    case 'success':
      return <Image src={tickSvg.src} width={16} height={16} />;
    case 'info':
      return <span>i</span>;
    case 'warning':
      return <Image src="/icons/warning.svg" alt="" width={24} height={24} />;
  }
};

const getColors = (type: AlertCardProps['type']) => {
  switch (type) {
    // @todo update colours for different states
    case 'success':
    case 'warning':
      return { borderColor: '#E49700', backgroundColor: '#FFF' };
    case 'info':
      return { borderColor: '#3979C5', backgroundColor: '#F2F8FF' };
  }
};

export const AlertCard = ({ children, type, className }: AlertCardProps) => {
  const { colors, componentProperties } = useTheme();
  const { borderColor, backgroundColor } = getColors(type);
  return (
    <Card
      className={className}
      border={`1px solid ${borderColor}`}
      backgroundColor={backgroundColor}
      rounded
    >
      <div
        role="alert"
        css={{
          display: 'flex',
          gap: '21px',
        }}
      >
        {
          <span
            aria-hidden
            css={{
              width: 26,
              height: 26,
              flexShrink: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '100%',
              backgroundColor:
                componentProperties.alertCard?.icon?.backgroundColor ??
                borderColor,
              fontSize: '20px',
              fontWeight: 600,
              color: colors.white,
            }}
          >
            <AlertIcon type={type} />
          </span>
        }
        <div>{children}</div>
      </div>
    </Card>
  );
};
